// API Constants and Endpoints - Updated to match Postman collection
export const API_ENDPOINTS = {
  // Health & System
  ROOT: '/',
  HEALTH: '/health/',
  HEALTH_DETAILED: '/health/detailed',
  HEALTH_DATABASE: '/health/database',
  
  // Dashboard - Fixed endpoints to match backend
  DASHBOARD: '/dashboard-master/',
  DASHBOARD_WITH_HASH: (hash: string) => `/dashboard-master?hash=${hash}`,
  DASHBOARD_HASH_ONLY: '/dashboard-master/hash',
  
  // Terminals
  TERMINALS: '/terminals/',
  TERMINAL_BY_ID: (id: number) => `/terminals/${id}`,
  
  // Checkpoints
  CHECKPOINTS: '/checkpoints/',
  CHECKPOINT_BY_ID: (id: number) => `/checkpoints/${id}`,
  CHECKPOINT_TOGGLE: (id: number) => `/checkpoints/${id}/toggle`,
  CHECKPOINT_TOGGLE_WITH_CASCADE: (id: number, cascade: boolean, updatedBy?: string) => {
    let url = `/checkpoints/${id}/toggle?cascade=${cascade}`;
    if (updatedBy) url += `&updated_by=${updatedBy}`;
    return url;
  },
  
  // Sections
  SECTIONS: '/sections/',
  SECTION_BY_ID: (id: number) => `/sections/${id}`,
  
  // Lane Assignments
  LANE_ASSIGNMENTS: '/laneassignments/',
  LANE_ASSIGNMENT_BY_ID: (id: number) => `/laneassignments/${id}`,
  LANE_ASSIGNMENT_CHANGE: (id: number) => `/laneassignments/${id}/change-assignment`,
  LANE_ASSIGNMENT_TOGGLE: (id: number) => `/laneassignments/${id}/toggle`,
  
  // Assets
  ASSETS: '/assets/',
  ASSET_BY_ID: (id: number) => `/assets/${id}`,
  ASSET_TOGGLE: (id: number) => `/assets/${id}/toggle`,
  
  // Asset Groups
  ASSET_GROUPS: '/assetgroups/',
  ASSET_GROUP_BY_ID: (id: number) => `/assetgroups/${id}`,
  
  // Legacy endpoints for backward compatibility
  SECTIONS_BY_CHECKPOINT: (checkpointId: number) => `/sections/?checkpoint_id=${checkpointId}`,
  CHECKPOINTS_BY_TERMINAL: (terminalId: number) => `/checkpoints/?terminal_id=${terminalId}`,
  CHECKPOINT_STATUS: (id: number) => `/checkpoints/${id}/status`,
  
  // Lane Types
  LANE_TYPES: '/lanetypes/',
  LANE_TYPE_BY_ID: (id: number) => `/lanetypes/${id}`,
  LANE_TYPES_BY_CHECKPOINT: (checkpointId: number) => `/lanetypes/?checkpoint_id=${checkpointId}`,
  
  // Display Summary API (New)
  DISPLAY_SUMMARY: '/display-summary',
} as const;

// HTTP Status Codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
} as const;

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  SERVER_ERROR: 'Server error. Please try again later.',
  NOT_FOUND: 'Resource not found.',
  VALIDATION_ERROR: 'Validation error. Please check your input.',
  UNKNOWN_ERROR: 'An unknown error occurred.',
} as const;

// Default API Headers
export const DEFAULT_HEADERS: Record<string, string> = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
};

// Calendar-related constants
export const CALENDAR_CONSTANTS = {
  DAYS_OF_WEEK: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  DAY_SHORT_NAMES: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  DAY_NUMBERS: {
    'sunday': 1,
    'monday': 2,
    'tuesday': 3,
    'wednesday': 4,
    'thursday': 5,
    'friday': 6,
    'saturday': 7
  },
  TIME_FORMATS: {
    DISPLAY: 'HH:MM',
    API: 'HH:MM:SS',
    INPUT: 'HHMM'
  }
} as const;

export default {
  API_ENDPOINTS,
  HTTP_STATUS,
  ERROR_MESSAGES,
  DEFAULT_HEADERS,
  CALENDAR_CONSTANTS,
};
